import { useMutation } from '@tanstack/react-query'
import { saveCardApi } from '@!/Api/externalPayment'

/**
 * カード登録のカスタムフック
 * GMOトークンを受け取ってカード登録を行う
 * @returns {Object} カード登録関数とステート
 */
export const useSaveCard = () => {
  const mutation = useMutation({
    mutationFn: ({ token, isUpdate }) => saveCardApi(token, isUpdate),
  })

  const saveCard = (token, isUpdate = false) => {
    return mutation.mutateAsync({ token, isUpdate })
  }

  return {
    saveCard,
    isLoading: mutation.isPending,
  }
}
